import React from 'react';
import styles from './aksje-andel-pill.module.less';
import { Text } from '@gjensidige/core-typography';
import { percent } from '@gjensidige/gpf-js-utils/es6/text/formatting';
import { text } from '../../../utils/text';
export var AksjeAndelPercentagePlassering;
(function (AksjeAndelPercentagePlassering) {
    AksjeAndelPercentagePlassering["ABOVE"] = "ABOVE";
    AksjeAndelPercentagePlassering["UNDER"] = "UNDER";
})(AksjeAndelPercentagePlassering || (AksjeAndelPercentagePlassering = {}));
export const AksjeAndelPill = ({ aksjeAndel, renteAndel, tekstPlassering = AksjeAndelPercentagePlassering.UNDER, }) => {
    if (aksjeAndel === undefined || renteAndel === undefined) {
        return null;
    }
    const style = {
        '--aksjeandel': `${aksjeAndel}%`,
    };
    return (React.createElement("div", { className: styles.container },
        tekstPlassering === AksjeAndelPercentagePlassering.ABOVE && (React.createElement("div", { className: styles.texts },
            React.createElement(Text, { size: "small" },
                React.createElement("span", { className: styles.fontBold }, percent(aksjeAndel)),
                ' ',
                text.FORM.RAADGIVNING_EGNETHET_RESULT.AKSJEANDEL.no),
            React.createElement(Text, { size: "small" },
                React.createElement("span", { className: styles.fontBold }, percent(renteAndel)),
                ' ',
                text.FORM.RAADGIVNING_EGNETHET_RESULT.RENTEANDEL.no))),
        React.createElement("div", { className: styles.pill, style: style }),
        tekstPlassering === AksjeAndelPercentagePlassering.UNDER && (React.createElement("div", { className: styles.texts },
            React.createElement(Text, { size: "small" },
                React.createElement("span", { className: styles.fontBold }, percent(aksjeAndel)),
                ' ',
                text.FORM.RAADGIVNING_EGNETHET_RESULT.AKSJEANDEL.no),
            React.createElement(Text, { size: "small" },
                React.createElement("span", { className: styles.fontBold }, percent(renteAndel)),
                ' ',
                text.FORM.RAADGIVNING_EGNETHET_RESULT.RENTEANDEL.no)))));
};
